import { DateInput, DateInputProps } from '@mantine/dates';
import { memo, useMemo } from 'react';
import { RegisterOptions, useController } from 'react-hook-form';
import styled from 'styled-components';
import {
	formatDateToBEIgnoreTimezone,
	parseBEDateIgnoreTimezone,
	parseUiDateDdMmYyyy,
} from '@dealstack/shared/lib/format/dates/date';

interface Props extends DateInputProps {
	rhfOptions?: RegisterOptions;
	name: string;
	className?: string;
}
// we must avoid creating our wrappers over mantine components but this case is exclusion bcs react-hook-form-mantine
// library dont export DateInput - D.Zghinnik 05.10.2023
const MantineDateInput = ({ name, rhfOptions, className, placeholder, ...props }: Props) => {
	const {
		field,
		fieldState: { error },
	} = useController({ name, rules: rhfOptions });

	const isOriginalValueIsString = typeof field.value === 'string';

	const datePickerDefaultLevel = useMemo(() => {
		return field.value ? 'month' : 'decade';
	}, [field.value]);

	return (
		<DateInput
			className={className}
			{...field}
			placeholder={placeholder ?? props.label?.toString() ?? 'Select date'}
			error={error?.message}
			value={(() => {
				if (!field.value) {
					return null;
				}
				return isOriginalValueIsString
					? parseBEDateIgnoreTimezone(field.value)
					: field.value;
			})()}
			valueFormat="DD/MM/YYYY"
			dateParser={parseUiDateDdMmYyyy}
			onChange={(value) =>
				field.onChange(
					(() => {
						if (!isOriginalValueIsString) {
							return value;
						}
						return value ? formatDateToBEIgnoreTimezone(value) : '';
					})()
				)
			}
			defaultLevel={props.defaultLevel || datePickerDefaultLevel}
			popoverProps={{
				withinPortal: true,
				zIndex: 1000,
			}}
			{...props}
		/>
	);
};

const Memoized = memo(MantineDateInput);
const Styled = styled(Memoized)`
	.mantine-Input-input {
		border: ${({ readOnly }) => (readOnly ? 'none' : '0.0625rem solid #D3D8DA')};
		${({ readOnly, leftSection }) =>
			!leftSection && (readOnly ? 'padding-left: 0px;' : 'padding-left: 0.5rem;')}
	}
`;

export { Styled as MantineDateInput };
